import {isEmpty} from 'lodash';
import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {changeWarehouseAllocationPage} from './allocations';
import {getFreeWarehouseLocations} from './locations';

export const checkLocationsAssignment = (warehouse, assignments) => apiActionCreator({
  'endpoint': `/warehouses/${warehouse}/locations/checkAssignments`,
  'authenticated': true,
  'types': [
    ActionTypes.CHECKING_ASSIGNMENT_IMPORT,
    [
      ActionTypes.CHECKED_ASSIGNMENT_IMPORT,
      MessageActions.addMessageBoxInfo('Archivo importado satisfactoriamente'),
    ],
    [
      ActionTypes.CHECKED_ASSIGNMENT_IMPORT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'contentType': 'application/json',
  'method': 'POST',
  'data': {assignments},
});

export const getAssignmentsList = (warehouse, params) => apiActionCreator({
  'endpoint': `/warehouses/${warehouse}/locations/${params.location}/assignments` +
    `?limit=${params.limit}&offset=${params.offset}`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_ASSIGNMENTS_LIST,
    ActionTypes.GOTTEN_ASSIGNMENTS_LIST,
    [
      ActionTypes.GOTTEN_ASSIGNMENTS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const submitLocationsAssignment = (warehouse, assignments, paramsForGetElementNextPage) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warehouses/${warehouse}/locations/assignments`,
      'authenticated': true,
      'types': [
        ActionTypes.SUBMITTING_LOCATIONS_ASSIGNMENT,
        [
          () => {
            if (!isEmpty(paramsForGetElementNextPage)) {
              dispatch(changeWarehouseAllocationPage(paramsForGetElementNextPage.offset));
              dispatch(getAssignmentsList(warehouse, paramsForGetElementNextPage));
            }
            dispatch(getFreeWarehouseLocations(warehouse));
            return {
              'type': ActionTypes.SUBMITTED_LOCATIONS_ASSIGNMENT,
            };
          },
          MessageActions.addMessageBoxInfo('Ubicaciones actualizadas satisfactoriamente'),
        ],
        [
          ActionTypes.SUBMITTED_LOCATIONS_ASSIGNMENT_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': {assignments},
    }),
  );
};

export const getPartAssignment = (warehouse, partCode, index) => apiActionCreator({
  'endpoint': `/warehouses/${warehouse}/locations/assignments/${partCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_PART_ASSIGNMENT,
    {
      'type': ActionTypes.GOTTEN_PART_ASSIGNMENT,
      'payload': index,
    },
    [
      ActionTypes.GOTTEN_PART_ASSIGNMENT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearLocationsAssignments = () => ({
  'type': ActionTypes.CLEAR_LOCATIONS_ASSIGNMENT,
});

export const addLocationAssignment = () => ({
  'type': ActionTypes.ADD_LOCATION_ASSIGNMENT,
});

export const removeLocationAssignment = (index) => ({
  'type': ActionTypes.REMOVE_LOCATION_ASSIGNMENT,
  'payload': index,
});

export const updateAssignmentValue = (index, name, value) => ({
  'type': ActionTypes.UPDATE_ASSIGNMENT_VALUE,
  'payload': {index, name, value},
});

export const showNewLocationsModal = (index) => ({
  'type': ActionTypes.SHOW_NEW_LOCATIONS_MODAL,
  'payload': {index},
});

export const hideNewLocationsModal = () => ({
  'type': ActionTypes.HIDE_NEW_LOCATIONS_MODAL,
});

export const showNewReservedLocationsModal = (index) => ({
  'type': ActionTypes.SHOW_NEW_RESERVED_LOCATIONS_MODAL,
  'payload': {index},
});

export const hideNewReservedLocationsModal = () => ({
  'type': ActionTypes.HIDE_NEW_RESERVED_LOCATIONS_MODAL,
});

export const fetchPartReplacement = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/replacement`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PART_REPLACEMENT,
    ActionTypes.FETCHED_PART_REPLACEMENT,
    [
      ActionTypes.FETCHED_PART_REPLACEMENT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
